import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import EditIcon from '@material-ui/icons/Edit';
// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';

import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';

import CouponForm from './CouponForm';
import { COUPON_STATUS_STRING } from 'constants/coupon';

import * as dbHelper from "db";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  }
};

class CouponManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      addressModalIsOpen: false,
      addressData: null,
      unsubscribe: null,
      alert: null,
      currentCoupon: null,
    };
  }

  componentDidMount() {
    this.unsubscribe = this.props.loadCoupons();
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  requestClose = () => { this.setState({ modalIsOpen: false }) }

  renderCouponForm = () => {
    return <Modal
      isOpen={this.state.modalIsOpen}
    // size='lg'
    >
      <ModalHeader toggle={this.requestClose}>쿠폰 정보</ModalHeader>
      <ModalBody>
        <CouponForm
          coupon={this.state.currentCoupon}
          requestClose={this.requestClose}
          showAlertAction={this.props.showAlertAction}
        />
      </ModalBody>
    </Modal>
  }

  render() {
    const { classes } = this.props;
    return (
      <Container>
        <Row>
          <Col>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>쿠폰 관리</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col className='text-right'>
                    <Button
                      color="primary"
                      onClick={() => {
                        this.setState({
                          modalIsOpen: true,
                          isEdit: false,
                        });
                      }}>신규 쿠폰 등록</Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ReactTable
                      {...reactTableDefaultProps}
                      data={this.props.coupons}
                      columns={[
                        {
                          id: '쿠폰번호',
                          Header: "쿠폰번호",
                          accessor: d => d.ref.id
                        },
                        {
                          id: '발급상한',
                          Header: "발급 상한",
                          accessor: d => d.data().max_count
                        },
                        {
                          id: '현재발급수',
                          Header: "현재 발급 개수",
                          accessor: d => d.data().cur_count
                        },
                        {
                          id: '상태',
                          Header: "상태",
                          accessor: d => COUPON_STATUS_STRING[d.data().status]
                        },
                        {
                          id: "created_at",
                          Header: "생성일",
                          accessor: d => {
                            const created_at = d.data().created_at;
                            return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD')
                          }
                        },
                        {
                          id: "expires_at",
                          Header: "만료일",
                          accessor: d => {
                            const expires_at = d.data().expires_at;
                            return moment(expires_at ? expires_at.toDate() : null).format('YYYY-MM-DD')
                          }
                        },
                        {
                          id: "action",
                          Header: "명령",
                          accessor: d => {
                            return (
                              // we've added some custom button actions
                              <div className="actions-right">
                                {/* use this button to remove the data row */}
                                <Button
                                  justIcon
                                  round
                                  simple
                                  onClick={() => {
                                    this.setState({ modalIsOpen: true, currentCoupon: d })
                                  }}
                                  color="warning"
                                  className="edit"
                                >
                                  <EditIcon />
                                </Button>{" "}
                                <Button
                                  justIcon
                                  round
                                  simple
                                  onClick={() => {
                                    this.setState({
                                      alert: (
                                        <SweetAlert
                                          warning
                                          style={{ display: "block", marginTop: "-100px" }}
                                          title="삭제 하시겠습니까?"
                                          onConfirm={() => {
                                            const coupon_id = d.id;
                                            return dbHelper.removeCoupon(coupon_id)
                                              .then(() => {
                                                this.setState({
                                                  alert: null
                                                });
                                                return this.props.showAlertAction({
                                                  message: `삭제되었습니다.`,
                                                  color: 'danger',
                                                })
                                              })
                                          }}
                                          onCancel={() => this.setState({
                                            alert: null
                                          })}
                                          confirmBtnCssClass={
                                            this.props.classes.button + " " + this.props.classes.success
                                          }
                                          cancelBtnCssClass={
                                            this.props.classes.button + " " + this.props.classes.danger
                                          }
                                          confirmBtnText="네 삭제합니다."
                                          cancelBtnText="취소"
                                          showCancel
                                        >
                                          한번 삭제하면 복구가 불가능합니다.
                                        </SweetAlert>
                                      )
                                    })
                                  }}
                                  color="danger"
                                  className="remove"
                                >
                                  <Close />
                                </Button>{" "}
                              </div>
                            )
                          },
                          sortable: false,
                          filterable: false
                        }
                      ]}
                    // getTrProps={(state, rowInfo) => {
                    //   if (rowInfo && rowInfo.row) {
                    //     return {
                    //       onClick: e => {
                    //         const d = rowInfo.original;
                    //         this.setState({ modalIsOpen: true, currentCoupon: d })
                    //       }
                    //     };
                    //   } else {
                    //     return {};
                    //   }
                    // }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {
          this.renderCouponForm()
        }
        {this.state.alert}

      </Container>
    );
  }
}


CouponManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    coupons: state.coupon.coupons
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CouponManager);